import SeoLinks from "./SeoLinks";
import TabbedLinks from "./SeoTabbedLinks";
import { ISEOTrendingBlock } from "models/seoTrendingBlocks";

interface IProps {
  seoTrendingBlocks: ISEOTrendingBlock[];
}

const SEOTrendingLinks = (props: IProps) => {
  const { seoTrendingBlocks } = props;
  return (
    <>
      {seoTrendingBlocks?.map((block, index) =>
        block?.blocks ? (
          <TabbedLinks
            key={index}
            className={"tabbedData"}
            title={block.block_title}
            data={block.blocks}
            category={block?.category_reporting_name}
          />
        ) : (
          <SeoLinks
            key={index}
            className={"tabbedData"}
            title={block.block_title}
            data={block.groups}
          />
        )
      )}
    </>
  );
};

export default SEOTrendingLinks;
